import { CSSProperties, forwardRef, useEffect, useState } from 'react';
import { ProgressBarProps } from './ProgressBar.props';

import './ProgressBar.scss';
import clsx from 'clsx';

const ProgressBar = forwardRef<HTMLProgressElement, ProgressBarProps>(
  ({ className, percentage, style, ...rest }, ref) => {
    const [fixedPercentage, setFixedPercentage] = useState<number>(0);

    useEffect(() => {
      requestAnimationFrame(() => {
        setFixedPercentage(percentage ? Math.round(percentage * 100) / 100 : 0);
      });
    }, [percentage]);

    return (
      <progress
        className={clsx('progress-bar', className)}
        max={100}
        ref={ref}
        style={
          {
            ...style,
            '--progress-bar-value': `${fixedPercentage}%`,
          } as CSSProperties
        }
        value={fixedPercentage}
        {...rest}
      />
    );
  },
);

export default ProgressBar;
